'use strict';

angular
    .module('App.v1.Services')
    .factory('App.v1.Services.PhoneNumberValidation', function() {
        
        var BLACKLISTED_AREA_CODES = ['900', '976', '632'];
        
        var ERROR_MESSAGES = {
            nanpNoDigits: 'Phone number must contain digits',
            nanpTooShort: 'Phone number must be at least 10 digits. Be sure to include area code.',
            nanpInvalidLength: 'Phone number must be 10 digits or 11 digits starting with 1',
            nanpInvalidAreaCode: 'Area code must start with 2-9',
            nanpBlacklistedAreaCode: 'Phone number contains an invalid area code'
        };
        
        /**
         * Validates a phone number using NANP rules (same logic as server-side PhoneNumberHelper.ConvertToE164Nanp)
         * @param {string} phoneNumber - The phone number to validate
         * @returns {object} - Object with isValid (boolean), errorKey (string), and errorMessage (string)
         */
        function validateNanp(phoneNumber) {
            // Empty values are valid (handled by ng-required)
            if (!phoneNumber || phoneNumber.trim() === '') {
                return { isValid: true, errorKey: null, errorMessage: null };
            }
            
            // Remove all non-numeric characters
            var digitsOnly = phoneNumber.replace(/\D/g, '');
            
            // Check if we have any digits at all
            if (digitsOnly.length === 0) {
                return { 
                    isValid: false, 
                    errorKey: 'nanpNoDigits', 
                    errorMessage: ERROR_MESSAGES.nanpNoDigits 
                };
            }
            
            // Must be at least 10 digits
            if (digitsOnly.length < 10) {
                return { 
                    isValid: false, 
                    errorKey: 'nanpTooShort', 
                    errorMessage: ERROR_MESSAGES.nanpTooShort 
                };
            }
            
            // Check if it's 10 digits OR 11 digits starting with "1"
            if (!(digitsOnly.length === 10 || (digitsOnly.length === 11 && digitsOnly[0] === '1'))) {
                return { 
                    isValid: false, 
                    errorKey: 'nanpInvalidLength', 
                    errorMessage: ERROR_MESSAGES.nanpInvalidLength 
                };
            }
            
            // Extract area code
            var areaCode;
            if (digitsOnly.length === 10) {
                areaCode = digitsOnly.substring(0, 3);
            } else if (digitsOnly.length === 11) {
                areaCode = digitsOnly.substring(1, 4);
            }
            
            // Validate area code starts with 2-9
            if (areaCode && (areaCode[0] < '2' || areaCode[0] > '9')) {
                return { 
                    isValid: false, 
                    errorKey: 'nanpInvalidAreaCode', 
                    errorMessage: ERROR_MESSAGES.nanpInvalidAreaCode 
                };
            }
            
            // Check for blacklisted area codes
            if (BLACKLISTED_AREA_CODES.indexOf(areaCode) !== -1) {
                return { 
                    isValid: false, 
                    errorKey: 'nanpBlacklistedAreaCode', 
                    errorMessage: ERROR_MESSAGES.nanpBlacklistedAreaCode + ' (' + areaCode + ')' 
                };
            }
            
            return { isValid: true, errorKey: null, errorMessage: null };
        }
        
        // Public API
        return {
            validateNanp: validateNanp,
            ERROR_MESSAGES: ERROR_MESSAGES,
            BLACKLISTED_AREA_CODES: BLACKLISTED_AREA_CODES
        };
    });
